import './bootstrap';
import './components';
import Navigation from './utils/navigation';
import Modal from './utils/modal';
import Dirs21 from './utils/dirs21';
import './utils/arbitraer.js';

let app = {}
let navigation = {}
let modal = {}

function init() {
    // create vue instance
    app = new Vue({
        el: '#app',
        created() {
            AOS.init();
        }
    });
    navigation = new Navigation;
    modal = new Modal;
    new Dirs21;
    window.locale = document.documentElement.lang;
}

document.addEventListener('DOMContentLoaded', function() {
    init()
}, false);
